import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import Thread from 'Components/threads/ThreadComponent';
import { trackGAEvent } from 'Actions/adsActions';
import { markAsRead } from 'Actions/ThreadviewActions';

import forumViewSelector from 'Selectors/forumViewSelector';

class AnnouncementThreadListComponent extends React.Component {
	expandMessage = ( event ) => {
		if( event.currentTarget.dataset.announcementid ) {
			let aId = parseInt( event.currentTarget.dataset.announcementid ),
				collapsed = event.currentTarget.classList.contains( 'collapsed' );

			// mark as read
			if( collapsed && this.props.forumview.entities.announcements[ aId ].unread ) {
				this.props.dispatch( markAsRead( aId, 'announcement' ) );
			} else {
				window.scrollTo( 0, 0 );
			}

			event.currentTarget.classList.toggle( 'collapsed' );

			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, ( collapsed ? 'expandAnnouncement' : 'collapseAnnouncement' ), 'uiAction', 'tap') );
		}
	};

	buildAnnouncement = ( key, topic, users ) => {
		return (
			<li key={ `announcements_${key}` } className="announcement collapsed" data-announcementid={ topic.id } onClick={ this.expandMessage }>
				<Thread
					thread={ topic }
					isSubscribable={ false }
					expandedContent={ topic.message }
					user={ users[topic.forumUser] }
					users={ users }
					dispatch={ this.props.dispatch }
					ustate={ this.props.ustate }
				/>
			</li>
		);
	};

	render() {
		const {entities: {users, announcements}, result} = this.props.forumview;

		if (result.announcements.length === 0) {
			return null
		}

		const announcementList = result.announcements.map( ( k, i ) => this.buildAnnouncement( i, announcements[ k ], users ) );

		return (
			<div id="announcements" className="threads announcement" >
				<div className="list-summary">
					Announcements ( { result.announcements.length } Topic{ result.announcements.length === 1 ? '' : 's' } )
				</div>
				<ul>
					{ announcementList }
				</ul>
			</div>
		);
	}
}

AnnouncementThreadListComponent.propTypes = {
	dispatch: PropTypes.func.isRequired,
	forumview: PropTypes.object.isRequired,
	ustate: PropTypes.object.isRequired
};

export default connect( forumViewSelector )( AnnouncementThreadListComponent );


// WEBPACK FOOTER //
// ./src/components/threads/AnnouncementThreadListComponent.js